(() => {
  if (customElements.get('grig-category-cards')) return;

  customElements.define('grig-category-cards', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.gcc-track');
      const nav = this.querySelector('.gcc-nav');
      const prev = this.querySelector('[data-gcc-prev]');
      const next = this.querySelector('[data-gcc-next]');
      if (!track || !nav || !prev || !next || this.gccCleanup) return;

      const mouse = matchMedia('(hover: hover) and (pointer: fine)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let frame = 0;
      const update = () => {
        frame = 0;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        nav.hidden = !mouse.matches || max <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max - 1;
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(update);
      };
      const move = direction => {
        const card = track.querySelector('.gcc-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const root = document.documentElement;
        const moving = root.dataset.grigMotion === 'true' &&
          !root.classList.contains('gm-off') && !reduced.matches;
        track.scrollBy({
          left: direction * (card.getBoundingClientRect().width + gap),
          behavior: moving ? 'smooth' : 'auto'
        });
      };
      const previous = () => move(-1);
      const following = () => move(1);
      prev.addEventListener('click', previous);
      next.addEventListener('click', following);
      track.addEventListener('scroll', schedule, { passive: true });
      mouse.addEventListener('change', schedule);
      const resize = new ResizeObserver(schedule);
      resize.observe(track);
      this.gccCleanup = () => {
        cancelAnimationFrame(frame);
        resize.disconnect();
        mouse.removeEventListener('change', schedule);
        track.removeEventListener('scroll', schedule);
        prev.removeEventListener('click', previous);
        next.removeEventListener('click', following);
      };
      update();
    }

    disconnectedCallback() {
      if (this.gccCleanup) this.gccCleanup();
      this.gccCleanup = null;
    }
  });
})();
